import React, { Component } from 'react';

const CancelComponent = ({handleCancelButtonClick}) => {

    return (
        <div className='cancel-bottom-bar' style={{textAlign:'center',padding:'10px'}}>
            <div onClick={()=>{handleCancelButtonClick()}} className="cursor-pointer cancel_div">
                <span  className='bottom-menu grey-cross'></span>
                <span className="fs-10 color-grey text-center display-block">Cancel</span>
            </div>
        </div>
    )


}

export default CancelComponent


// WEBPACK FOOTER //
// ./src/components/bottom-components/cancel.component.js